import React, { useContext } from "react";
import { string, instanceOf, bool } from "prop-types";
import * as i18n from "util/i18n";
import FormattedDate from "pages/_components/FormattedDate";
import { transactionStatus } from "pages/transactions/constants";
import { isDesktop } from "react-device-detect";
import { EcheqTransactionContext } from "./EcheqTransactionContext";
import CustomData from "../CustomData/CustomData";

export const EcheqTransactionSign = ({
    creationLastName,
    creationFirstName,
    // creationDate,
    signatures: _signatures,
    showSignatures,
    status,
    hasSignatures,
    noHorizontalDivider,
    isSmall,
    customText,
    hasVaucher,
}) => {
    const { transaction } = useContext(EcheqTransactionContext);
    const {
        userCreatorLastName = creationLastName,
        userCreatorFirstName = creationFirstName,
        // creationDateTime = creationDate,
        signatures = _signatures,
        idTransactionStatus = status,
        modificationDateTime,
        userEditorLastName,
        userEditorFirstName,
        idTransaction,
        creationDateTime,
    } = transaction;

    const isFinished = idTransactionStatus === transactionStatus.FINISHED;
    const isPending =
        idTransactionStatus === transactionStatus.PENDING || idTransactionStatus === transactionStatus.PROCESSING;
    const isCancelled = idTransactionStatus === transactionStatus.CANCELLED;

    const SignituresData = () => (
        <>
            <div className="pending-approval">
                <div className="tiny-small secondary">{i18n.get(customText || "pending.approval")}</div>
                <div className="tiny-small font-bold secondary">
                    <FormattedDate
                        className="small"
                        date={signatures[0]?.creationDateTime}
                        dateFormat="s/MM/YYYY HH:mm:ss"
                    />
                </div>
            </div>
        </>
    );
    return (
        <div className="signatures-data">
            <div className="ticket__divider signatures-divider inside-ticket__body">
                <div className="ticket__notch ticket__notch--left"> </div>
                <div className="ticket__notch ticket__notch--right"> </div>
            </div>
            <h2>{i18n.get("forms.transaction.ticket.title")}</h2>
            <div>
                <CustomData
                    titleText="forms.transaction.ticket.createdBy"
                    titleTextType="I18N"
                    valueText={`${userCreatorLastName}, ${userCreatorFirstName} (${signatures[0]?.signatureLevel})`}
                />
                <div className="tiny-small font-bold secondary">
                    <FormattedDate
                        className="small"
                        date={signatures[0]?.creationDateTime}
                        dateFormat="DD/MM/YYYY HH:mm:ss"
                    />
                </div>
            </div>
            {showSignatures && (
                <div className="approval-signature custom-data">
                    <div className="custom-text custom-data-title ">
                        {i18n.get("forms.transaction.ticket.signedBy")}
                    </div>
                    {signatures?.map((signature, index) => (
                        <span className="custom-text custom-data-value data-label">
                            {!!index && ", "}
                            {`${signature.userFullName} (${signature.signatureLevel}) ${!isSmall ? "-" : ""} `}
                            {isSmall ? (
                                <div className="tiny-small font-bold secondary">
                                    <FormattedDate date={signature.creationDateTime} dateFormat="DD/MM/YYYY HH:mm:ss" />
                                </div>
                            ) : (
                                <FormattedDate date={signature.creationDateTime} dateFormat="DD/MM/YYYY HH:mm:ss" />
                            )}
                            {}
                        </span>
                    ))}
                </div>
            )}
            {isCancelled && (
                <div className="canceled-signature">
                    <CustomData
                        titleText="forms.transaction.ticket.cancelledBy"
                        titleTextType="I18N"
                        valueText={`${userEditorLastName}, ${userEditorFirstName} - `}
                    />
                    <FormattedDate date={modificationDateTime} dateFormat="DD/MM/YYYY HH:mm:ss" />
                </div>
            )}
            {isPending && (
                <div className="pending-signature">
                    <div className="horizontal-divider" />
                    <SignituresData />
                </div>
            )}
            {isFinished && hasSignatures && (
                <div className="pending-signature">
                    {!noHorizontalDivider && <div className="horizontal-divider" />}
                    <SignituresData />
                    <div className="vaucher">
                        <CustomData
                            titleText="ticket.voucher"
                            titleTextType="I18N"
                            valueText={idTransaction.substring(0, 8)}
                            withPrintFormat={!isDesktop}
                        />
                    </div>
                </div>
            )}
            {isFinished && hasVaucher && (
                <>
                    <div className="pending-signature">
                        <div className="horizontal-divider" />
                        <div className="pending-approval">
                            <div className="tiny-small secondary">{i18n.get("transfer.dateHourtime")}</div>
                            <div className="tiny-small font-bold secondary">
                                <FormattedDate
                                    className="small"
                                    date={creationDateTime}
                                    dateFormat="DD/MM/YYYY HH:mm:ss"
                                />
                            </div>
                        </div>
                        <div className="vaucher">
                            <CustomData
                                titleText="ticket.voucher"
                                titleTextType="I18N"
                                valueText={idTransaction.substring(0, 8)?.toUpperCase()}
                                withPrintFormat={!isDesktop}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

EcheqTransactionSign.propTypes = {
    creationLastName: string,
    creationFirstName: string,
    signatures: instanceOf(Array),
    showSignatures: bool,
    status: string,
    isSmall: bool,
    customText: string,
    noHorizontalDivider: bool,
    hasSignatures: bool,
    hasVaucher: bool,
};

EcheqTransactionSign.defaultProps = {
    creationLastName: "",
    creationFirstName: "",
    signatures: [],
    showSignatures: true,
    status: "",
    isSmall: false,
    noHorizontalDivider: false,
    customText: "",
    hasSignatures: false,
    hasVaucher: false,
};

export default EcheqTransactionSign;
